import {Modal, ModalFooter, ModalOverlay} from '@/components/ui/modal-atoms/ModalAtoms'
import {
    StyledMedicalReportTextAreaModalBody,
    StyledMedicalReportTextAreaModalHeader,
    StyledMedicalReportTextAreaModalParagraph,
    StyledMedicalReportTextAreaModalTitle
} from './style'
import {MedicalReportTextAreaField} from '../medical-report-text-area-field/MedicalReportTextAreaField'
import {Button} from '@/components/ui/button/Button'
import {useTranslation} from '@/translations/i18n'
import {ChangeEvent, forwardRef, useCallback, useState} from 'react'
import {TextAreaProps} from '@/components/commons/textarea/TextArea'
import {useMedicalReportTextAreaStore} from '../../stores/medicalReportTextAreaStore'

interface MedicalReportTextAreaModal {
    title: string
    description?: string
    textAreaProps?: TextAreaProps
}

export const MedicalReportTextAreaModal = forwardRef<HTMLTextAreaElement, MedicalReportTextAreaModal>(
    ({title, description, textAreaProps}, ref) => {
        const {t} = useTranslation()

        const [value, setValue] = useState(
            textAreaProps?.value?.toString() || textAreaProps?.defaultValue?.toString() || ''
        )

        const {closeModal} = useMedicalReportTextAreaStore()

        const handleConfirm = useCallback(() => {
            textAreaProps?.onChange?.({target: {value}, currentTarget: {value}} as ChangeEvent<HTMLTextAreaElement>)
            closeModal()
        }, [closeModal, textAreaProps?.onChange, value])

        return (
            <>
                <ModalOverlay
                    onClick={event => {
                        event.stopPropagation()
                        closeModal()
                    }}
                />
                <Modal width="1024px">
                    <StyledMedicalReportTextAreaModalHeader>
                        <StyledMedicalReportTextAreaModalTitle>{title}</StyledMedicalReportTextAreaModalTitle>
                        {description && (
                            <StyledMedicalReportTextAreaModalParagraph>
                                {description}
                            </StyledMedicalReportTextAreaModalParagraph>
                        )}
                    </StyledMedicalReportTextAreaModalHeader>

                    <StyledMedicalReportTextAreaModalBody>
                        <MedicalReportTextAreaField
                            {...textAreaProps}
                            ref={ref}
                            value={value}
                            onChange={e => setValue(e.currentTarget.value.toString())}
                            canSplit
                        />
                    </StyledMedicalReportTextAreaModalBody>

                    <ModalFooter>
                        <Button variant="secondary" onClick={closeModal}>
                            {t('commons:cancel')}
                        </Button>
                        <Button variant="primaryNeutral" disabled={!value} onClick={handleConfirm}>
                            {t('commons:confirm')}
                        </Button>
                    </ModalFooter>
                </Modal>
            </>
        )
    }
)
